export default __webpack_public_path__ + "static/media/Bug--TrackerLogo(bug)black.b1776abc.svg";